import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, UserIcon, UsersIcon, StethoscopeIcon, BrainIcon, HeartIcon, PillIcon, ShieldAlertIcon } from 'lucide-react';
export function ServicesSection() {
  const serviceCategories = [{
    title: 'Personal Care',
    icon: <UserIcon className="w-6 h-6 text-accent" data-id="element-244" />,
    description: 'Assistance with daily living activities to maintain independence.',
    items: ['Bathing & Dressing', 'Grooming & Hygiene', 'Mobility Assistance', 'Toileting & Incontinence', 'Transfer Assistance']
  }, {
    title: 'Companion Care',
    icon: <UsersIcon className="w-6 h-6 text-accent" data-id="element-245" />,
    description: 'Emotional support and assistance with household tasks.',
    items: ['Socialization', 'Meal Preparation', 'Light Housekeeping', 'Errands & Shopping', 'Transportation']
  }, {
    title: 'Skilled Nursing',
    icon: <StethoscopeIcon className="w-6 h-6 text-accent" data-id="element-246" />,
    description: 'Professional medical care provided by licensed nurses.',
    items: ['Wound Care', 'Injections & IV Therapy', 'Vital Signs Monitoring', 'Post-Surgical Care', 'Catheter Care']
  }, {
    title: 'Specialized Care',
    icon: <BrainIcon className="w-6 h-6 text-accent" data-id="element-247" />,
    description: 'Expert care for specific health conditions and needs.',
    items: ["Alzheimer's & Dementia", 'Parkinson’s Care', 'Hospice Support', 'Physical Therapy', 'Occupational Therapy']
  }, {
    title: 'Complex Care',
    icon: <ShieldAlertIcon className="w-6 h-6 text-accent" data-id="element-248" />,
    description: 'High-level support for individuals with complex medical needs.',
    items: ['Level 3 Complex Care', 'Ventilator Support', 'Tracheostomy Care', 'Feeding Tube Management', 'Seizure Monitoring']
  }, {
    title: 'Support Services',
    icon: <HeartIcon className="w-6 h-6 text-accent" data-id="element-249" />,
    description: 'Additional services to support families and caregivers.',
    items: ['Respite Care', 'Medication Support', 'Doctor Visit Escort', 'End-of-Life Care', '24/7 Live-In Care']
  }];
  return <section id="services" className="py-24 px-4 bg-white" data-id="element-250">
      <div className="max-w-7xl mx-auto" data-id="element-251">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-252">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-heading font-bold text-neutral-dark mb-4" data-id="element-253">
            Our Services
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-neutral-medium" data-id="element-254">
            Comprehensive home health services tailored to your family's needs —
            all provided in the comfort of home.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-255">
          {serviceCategories.map((category, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-256">
              <div className="w-12 h-12 bg-primary/10 rounded-2xl flex items-center justify-center mb-6" data-id="element-257">
                {category.icon}
              </div>
              <h3 className="text-xl font-heading font-bold text-neutral-dark mb-3" data-id="element-258">
                {category.title}
              </h3>
              <p className="text-neutral-medium text-sm mb-6" data-id="element-259">
                {category.description}
              </p>
              <ul className="space-y-3 mb-8" data-id="element-260">
                {category.items.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-261">
                    <CheckCircle2Icon className="w-4 h-4 text-primary flex-shrink-0 mt-1" data-id="element-262" />
                    <span className="text-neutral-dark text-sm font-medium" data-id="element-263">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <div className="pt-6 border-t border-gray-100 mt-auto" data-id="element-264">
                <p className="text-xs text-neutral-medium mb-3" data-id="element-265">
                  Rates starting from competitive local averages
                </p>
                <a href="/contact" className="block text-center bg-primary/5 hover:bg-primary/10 text-primary font-bold py-3 rounded-xl transition-colors text-sm" data-id="element-266">
                  Get a Custom Quote
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}